import {atom} from "jotai";
import {
  AdmUserApi$CurrentAuthedUser,
} from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";

export type AdminAreaAuthedUserOrFalse = AdmUserApi$CurrentAuthedUser | false

export const uiAdminAreaAuthState = atom<AdminAreaAuthedUserOrFalse>(false)


